import { TableCell, TableRow } from "@mui/material"
import type { ReactElement, ReactNode } from "react"
import { twMerge } from "tailwind-merge"

interface TableNoDataFoundRowProps {
  children: ReactNode
  colSpan?: number
  className?: string
}

export const TableNoDataFoundRow = ({ children, colSpan, className }: TableNoDataFoundRowProps): ReactElement => {
  return (
    <TableRow>
      <TableCell colSpan={colSpan} align='center' className={twMerge("py-8", className)}>
        {children}
      </TableCell>
    </TableRow>
  )
}
